import React, { useState } from "react";
import ContractorRecordsLink from "../ContractorRecordsLink";
import { CONTRACTOR_AFFILIATIONS } from "../recordKinds";
import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

import * as moment from "moment";
import { useNavigate } from "react-router-dom";

const AffiliationsToContractor = ({ contractor }: { contractor: any }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();

  const contractorAffiliations = contractor?.contractorAffiliations || [];
  const contractorAffiliatedTo = contractor?.contractorAffiliatedTo || [];
  const totalAffiliations =
    contractorAffiliations.length + contractorAffiliatedTo.length;
  return (
    <Card>
      <CardHeader
        className={`d-flex align-items-center ${
          isOpen ? "border-bottom-dashed" : ""
        }`}
        onClick={toggleCollapse}
        style={{ cursor: "pointer" }}
      >
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">
            Affiliations to Contractor
            <small
              color="light"
              className="badge bg-primary-subtle align-bottom ms-1 text-primary"
            >
              {totalAffiliations}
            </small>
          </h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <ContractorRecordsLink contractor={contractor} config={CONTRACTOR_AFFILIATIONS} />
        </div>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className="card-body">
          <ListGroup flush>
            {contractorAffiliations.map((item: any, index: number) => (
              <ListGroupItem
                tag="a"
                to="#"
                className="list-group-item-action"
                onClick={() => {
                  navigate(`/contractors/${item?.affiliatedTo?.id}`);
                }}
                style={{ cursor: "pointer" }}
                key={index}
              >
                <div className="float-end">
                  <div>
                    <i className="ri-time-line align-bottom me-1"></i>{" "}
                    {moment(new Date(item?.updatedAt)).format("DD MMM, Y")}
                  </div>
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <div className="flex-shrink-0">
                    <div className="avatar-sm  rounded">
                      <div className="avatar-title bg-primary-subtle text-primary rounded fs-24">
                        <i className="ri-building-line text-primary"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h5 className="list-title fs-15 mb-1">
                      {item?.affiliatedTo?.contractorName || ""}
                    </h5>
                    <p className="list-text mb-0 fs-12">
                      {item?.affiliatedTo?.organizationType?.name || ""}
                    </p>
                  </div>
                </div>
              </ListGroupItem>
            ))}

            {contractorAffiliatedTo.map((item: any, index: number) => (
              <ListGroupItem
                tag="a"
                to="#"
                className="list-group-item-action"
                onClick={() => {
                  navigate(`/contractors/${item?.contractor?.id}`);
                }}
                style={{ cursor: "pointer" }}
                key={index}
              >
                <div className="float-end">
                  <div>
                    <i className="ri-time-line align-bottom me-1"></i>{" "}
                    {moment(new Date(item?.updatedAt)).format("DD MMM, Y")}
                  </div>
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <div className="flex-shrink-0">
                    <div className="avatar-sm  rounded">
                      <div className="avatar-title bg-primary-subtle text-primary rounded fs-24">
                        <i className="ri-building-line text-primary"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h5 className="list-title fs-15 mb-1">
                      {item?.contractor?.contractorName || ""}
                    </h5>
                    <p className="list-text mb-0 fs-12">
                      {item?.contractor?.organizationType?.name || ""}
                    </p>
                  </div>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default AffiliationsToContractor;
